<template>
  <Card class="fdv">
    <template #header>
      <h2>{{ $t('documentation') }}</h2>
    </template>
    <template #default>
      <Directory :value="items" readonly :exclude-types="['link']">
        <template #content-top="{ item }">
          <Links v-if="getLink(item).length" :value="getLink(item)[0].files" />
        </template>
      </Directory>
    </template>
  </Card>
</template>

<script>
import { mapState } from 'vuex'

import Card from '@/components/Card'
import Directory from '@kvass/directories'
import Links from '@/components/Links'

export default {
  computed: {
    ...mapState('ResidentialAccount', ['promises', 'item']),
    items() {
      if (!this.$path('item.documents.length')) return []

      return this.item.documents.map(item => {
        return {
          ...item,
          files: (this.$path('files', item) || []).filter(file => file.type !== 'link'),
        }
      })
    },
  },
  methods: {
    getLink(target) {
      if (!this.$path('item.documents.length')) return []

      return this.item.documents
        .map(item => {
          return {
            ...item,
            files: (this.$path('files', item) || []).filter(file => file.type && file.type === 'link'),
          }
        })
        .filter(link => {
          if (!this.$path('files.length', link)) return
          return link.path === target.path
        })
    },
  },
  components: {
    Card,
    Directory,
    Links,
  },
}
</script>

<style lang="scss">
.fdv {
  .card__header {
    min-height: initial;
    flex-direction: row;
    justify-content: flex-start;

    h2 {
      margin: 0;
    }
  }
}
</style>
